import { Heading, StepList } from '@boltenergy-be/design-system'
import Link from 'components/link/Link.tsx'
import { routes } from 'types/routes.ts'
import { useTranslation } from 'react-i18next'

const Confirmation = () => {
  // i18n
  const { t } = useTranslation('support', { keyPrefix: 'complaintForm.confirmation' })

  return (
    <>
      <Heading as="h2">{t(($) => $.title)}</Heading>
      <p>{t(($) => $.description)}</p>

      <div className="flex-col gap-400 my-500">
        <Heading as="h2" variant="h3">
          {t(($) => $.subtitle)}
        </Heading>
        <StepList size="small">
          {(
            t(($) => $.steps, {
              returnObjects: true
            }) as Array<{ title: string; description: string }>
          ).map((step, index) => (
            <li key={index}>
              <div className="flex-col">
                <strong>{step.title}</strong>
                <p>{step.description}</p>
              </div>
            </li>
          ))}
        </StepList>
      </div>

      <Link href={routes.OVERVIEW} representation="button">
        {t(($) => $.action)}
      </Link>
    </>
  )
}

export default Confirmation
